import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const ConnectionStatusContainer = styled('div')<{
    theme?: TTheme
}>`
    display: flex;
    align-items: center;
    gap: 6px;
`
export const PartialConnectionStatusContainer = styled('div')<{
    theme?: TTheme
}>`
    display: flex;
    align-items: center;
    gap: 6px;
    svg {
        color: ${({ theme }) => theme.colors.semantic.partialActiveIndicator};
        margin-top: -2px;
    }
    &:hover {
        cursor: pointer;
        text-decoration: underline;
        text-underline-offset: 3px;
        svg {
            color: ${({ theme }) =>
                theme.colors.semantic.partialActiveIndicatorHover};
        }
    }
`
